import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild
} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {MatDivider} from "@angular/material/divider";

import {TranslocoPipe} from "@ngneat/transloco";
import {DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";
import {DocummentsService} from "../../../documents.service";
import {GeneralFieldNames} from "../../../document-types";
import {AcordPacientInformatFieldNames, StaffPerson} from "../../acord-pacient-informat.types";
import {BasicInfoFieldNames} from "../../../basic-info/basic.patient.info.types";
import {BasicTemplate} from "../../../base-behaviour/template";
import {docCSS, getRawVal, getValueOfFieldWithName} from "../../../base-behaviour/base.behaviour.doc.types";

@Component({
    selector: 'acord-pacient-informat-sib-v2-template',
    templateUrl: 'acord-pacient-informat-template-sib-v2.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatIcon,
        MatDivider,
        TranslocoPipe,
        NgIf,
        NgClass,
        NgForOf,
        DatePipe

    ],
    standalone: true,
    styles: `
        table {
            width: 100%;
            border-collapse: collapse;
            margin: 0 auto;
        }

        thead {
            background-color: #cdcdcd;
            color: black;
            text-align: center;
        }

        .leftAlignHead {
            background-color: #cdcdcd;
            color: black;
            text-align: left;
        }

        th, td {
            border: 1px solid black;
            padding: 8px;
        }

        body {
            font-family: Arial, sans-serif;
            background-color: #ffffff;
            margin: 0;
            padding: 0;
        }

        .content-container {
            width: 95%;
            padding: 1.5cm 1cm 1.5cm 1cm;
        }

        h1 {
            font-size: x-large;
            text-align: center;
            font-weight: bold;
        }

        h4 {
            color: #8e8e8e;
            text-align: right;
            font-size: small;
            font-weight: bold;
        }

        .section {
            margin-bottom: 15px;
        }

        label {
            display: block;
            margin-bottom: 5px;
        }

        input {
            width: 100%;
            padding: 8px;
            border: 1px solid #ccc;
            border-radius: 4px;
        }
    `
})
export class AcordPacientInformatTemplateSibV2 extends BasicTemplate implements OnInit, OnDestroy {
    protected readonly AcordPacientInformatFieldNames = AcordPacientInformatFieldNames;
    protected readonly BasicInfoFieldNames = BasicInfoFieldNames;
    protected readonly GeneralFieldNames = GeneralFieldNames;
    private staff:StaffPerson[] = [];

    constructor(
        route: ActivatedRoute,
        router: Router,
        _docsService:DocummentsService,
        _cdref: ChangeDetectorRef,
    ) {
        super(_docsService, _cdref, router, route);
    }

    ngOnInit(): void {
        this.init();
    }

    ngOnDestroy(): void {
        this.destroy();
    }


    getStaffInfo() {
        let found = true;
        const rez: StaffPerson[] =[];
        let index=1;
        while(found){
            const nume = getValueOfFieldWithName(this.docFields, `clinic_person${index}_name`, this.documentID);
            const profesie =  getValueOfFieldWithName(this.docFields, `clinic_person${index}_proffession`, this.documentID);
            const grad = getValueOfFieldWithName(this.docFields, `clinic_person${index}_grad`  , this.documentID);

            const entry:StaffPerson = {
                numeSiPrenume: nume,
                profesie: profesie,
                gradSpecialitate: grad
            }
            if(nume){
                rez.push(entry);
                index++;
            }else{
                found = false;
            }
        }

        return rez;
    }


    getMedicName() {
        const staff: StaffPerson[] = this.getStaffInfo();
        if(staff?.length > 0){
            return staff[0].numeSiPrenume;
        }
        return "";
    }

    accepted() {
        const data = this.getFieldData(AcordPacientInformatFieldNames.API_SB_V2__acord);
        return data === "ACCEPT";
    }

    getDescriptionInvestParaclinice() {
        let rez = this.getFieldData(GeneralFieldNames.clinic_investigatii_paraclinice);
        rez = rez?rez:"-";
        return rez;
    }

    protected readonly getValueOfFieldWithName = getValueOfFieldWithName;
}
